import { cn } from "@/lib/utils";

export function Button({ className, variant = "primary", size = "md", ...props }) {
  const variants = {
    primary: "bg-primary text-primary-foreground hover:bg-brand-lime-hover font-semibold",
    outline: "border border-border text-foreground hover:border-primary hover:text-primary",
    ghost: "text-muted-foreground hover:text-foreground hover:bg-secondary",
    danger: "bg-destructive text-destructive-foreground hover:opacity-90",
  };
  const sizes = { sm: "px-3 py-1.5 text-sm", md: "px-4 py-2.5 text-sm", lg: "px-6 py-3 text-base" };
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-lg transition-all disabled:opacity-50 disabled:pointer-events-none",
        variants[variant], sizes[size], className,
      )}
      {...props}
    />
  );
}

export function Input({ className, ...props }) {
  return (
    <input
      className={cn(
        "w-full rounded-lg bg-secondary/60 border border-input px-3 py-2.5 text-sm text-foreground",
        "placeholder:text-muted-foreground/60 outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors",
        className,
      )}
      {...props}
    />
  );
}

export function Select({ className, children, ...props }) {
  return (
    <select
      className={cn(
        "w-full rounded-lg bg-secondary/60 border border-input px-3 py-2.5 text-sm text-foreground",
        "outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors",
        className,
      )}
      {...props}
    >
      {children}
    </select>
  );
}

export function Label({ className, ...props }) {
  return <label className={cn("block text-xs font-medium uppercase tracking-wide text-muted-foreground mb-1.5", className)} {...props} />;
}

export function Card({ className, ...props }) {
  return <div className={cn("rounded-xl border border-border bg-card p-6", className)} {...props} />;
}

const STATUS_STYLES = {
  sent: "bg-yellow-500/10 text-yellow-400 border-yellow-500/30",
  paid: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  active: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  failed: "bg-red-500/10 text-red-400 border-red-500/30",
  canceled: "bg-zinc-500/10 text-zinc-400 border-zinc-500/30",
};
const STATUS_LABELS = { sent: "Awaiting payment", paid: "Paid", active: "Active (recurring)", failed: "Payment failed", canceled: "Canceled" };

export function StatusBadge({ status }) {
  return (
    <span className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium", STATUS_STYLES[status] || STATUS_STYLES.canceled)}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function Spinner({ className }) {
  return (
    <div className={cn("h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent", className)} />
  );
}

export function money(cents, currency = "usd") {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: (currency || "usd").toUpperCase() }).format((cents || 0) / 100);
}
